export default __webpack_public_path__ + "static/media/Imao_Keinen_A_Pair_of_Peacocks_in_spring_35_x_70_cm.30231ead.jpg";